/* Kanva theme JS: AJAX cart, product gallery, variant sync, mobile nav. */
(function () {
  'use strict';

  var moneyFormat = window.KanvaMoneyFormat || '${{amount}}';
  var rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var strings = window.KanvaStrings || {};

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0] + ',' + parts[1];
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* ----- Toast ----- */
  var toastTimer;
  function showToast(text) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('.kv-toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 3200);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function sellingPlanMap(form) {
    var node = (form && form.querySelector('[data-kv-selling-plans]')) ||
      document.querySelector('[data-kv-selling-plans]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function syncSellingPlan(form) {
    var map = sellingPlanMap(form);
    if (!map) return;
    var chosen = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!chosen || !chosen.value) return;
    var allowed = map[String(chosen.value)] || [];
    var planInputs = form.querySelectorAll('[name="selling_plan"]');
    if (!planInputs.length) return;

    planInputs.forEach(function (input) {
      var plan = String(input.value || '').trim();
      if (!plan || plan === '0') return;
      var planId = Number(plan);
      var ok = allowed.some(function (id) {
        return Number(id) === planId;
      });
      if (ok) return;
      input.value = allowed.length ? String(allowed[0]) : '';
    });
  }

  /* ----- AJAX add to cart ----- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    event.preventDefault();
    if (form.getAttribute('data-kv-adding') === '1') return;
    form.setAttribute('data-kv-adding', '1');

    var locked = [];
    function lockButtons(on) {
      var formId = form.getAttribute('id');
      var nodes = form.querySelectorAll('[type="submit"], [data-variant-card-atc]');
      if (formId) {
        nodes = document.querySelectorAll(
          'form#' + formId + ' [type="submit"], form#' + formId + ' [data-variant-card-atc], [form="' + formId + '"][type="submit"]'
        );
      }
      nodes.forEach(function (btn) {
        if (on) {
          if (!btn.disabled) locked.push(btn);
          btn.setAttribute('disabled', 'disabled');
        } else if (locked.indexOf(btn) !== -1) {
          btn.removeAttribute('disabled');
        }
      });
      if (!on) locked = [];
    }
    lockButtons(true);

    /* Kaching (and other subscription apps) leave a selling_plan on the form.
       Each pack variant only accepts its own plan (1 jar = monthly, 3 jars =
       every 3 months). Remap or drop the plan so add-to-cart does not 422. */
    syncSellingPlan(form);

    fetch(rootRoute + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (data) { throw data; });
        return response.json();
      })
      .then(function (item) {
        return fetch(rootRoute + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            // The cart drawer is the primary feedback when present; only toast otherwise.
            if (!document.querySelector('[data-cart-drawer]')) {
              var template = strings.addedToBag || '{{ title }} added to bag';
              showToast(template.replace(/\{\{\s*title\s*\}\}/, item.product_title || 'Item'));
            }
            document.dispatchEvent(new CustomEvent('kanva:cart-added', { detail: { item: item, cart: cart } }));
          });
      })
      .catch(function (error) {
        showToast(error && error.description ? error.description : strings.addError || 'Could not add to bag');
      })
      .finally(function () {
        form.removeAttribute('data-kv-adding');
        lockButtons(false);
      });
  });

  /* ----- Product gallery thumbs ----- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;

    var stage = gallery.querySelector('[data-stage] img');
    if (stage) {
      stage.src = thumb.dataset.src;
      if (thumb.dataset.srcset) stage.srcset = thumb.dataset.srcset;
      else stage.removeAttribute('srcset');
      stage.alt = thumb.dataset.alt || '';
    }
    gallery.querySelectorAll('[data-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  /* ----- Buy-box description: Read more / Show less ----- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-kv-copy-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-kv-copy]');
    if (!wrap) return;
    var expanded = !wrap.classList.toggle('is-clamped');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded
      ? (toggle.dataset.less || 'Show less')
      : (toggle.dataset.more || 'Read more');
  });

  /* ----- Variant selection: sync CTA price ----- */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-variant-radio]')) return;
    var form = input.closest('form');
    if (!form) return;

    var priceEl = form.querySelector('[data-cta-price]');
    if (priceEl) priceEl.textContent = formatMoney(parseInt(input.dataset.price, 10));

    var button = form.querySelector('[type="submit"]');
    if (button) {
      if (input.dataset.available === 'false') {
        button.setAttribute('disabled', 'disabled');
        button.querySelector('[data-cta-label]').textContent = button.dataset.soldOutText || 'Sold out';
      } else {
        button.removeAttribute('disabled');
        button.querySelector('[data-cta-label]').textContent = button.dataset.addText || 'Add to Cart';
      }
    }

    // Keep the URL shareable/deep-linkable for the selected variant.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    }
  });

  /* ----- Quantity steppers ----- */
  document.addEventListener('click', function (event) {
    var stepBtn = event.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    var wrap = stepBtn.closest('.kv-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(stepBtn.dataset.qtyStep, 10);
    input.value = Math.max(parseInt(input.min, 10) || 0, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Cart page quantity auto-submit ----- */
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-qty]')) return;
    var form = event.target.closest('form');
    if (form) form.submit();
  });

  /* ----- Mobile nav ----- */
  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-mobile-toggle]');
    if (!burger) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Article tables: keep wide columns readable on phones without crushing type. */
  document.querySelectorAll('.kv4-article__body table').forEach(function (table) {
    if (table.parentNode && table.parentNode.classList.contains('kv4-article__tablewrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'kv4-article__tablewrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* Topic rail: tags run alphabetically, so the one you just picked can sit well
     past the right edge. Centre it on load, without smooth scrolling, so the
     page does not appear to slide on first paint. */
  document.querySelectorAll('[data-topic-rail]').forEach(function (rail) {
    var current = rail.querySelector('.is-active');
    if (!current) return;
    /* Measured, not offsetLeft: the pill's offsetParent is whichever ancestor
       happens to be positioned, which is not the rail. */
    var railBox = rail.getBoundingClientRect();
    var pillBox = current.getBoundingClientRect();
    var offset = pillBox.left - railBox.left - (railBox.width - pillBox.width) / 2;
    rail.scrollLeft = Math.max(0, rail.scrollLeft + offset);
  });
})();
